/* eslint-disable no-case-declarations */
import {
    GET_CATEGORIES,
    CategoryActions,
  } from "../../types/actions/Category.actions";
  import { Category } from "../../types/models/Category";
  import { CategoryState } from "../../types/models/CategoryState";
  
  const initialSettings: CategoryState = {
    categories: undefined,
  };
  
  const CategoryReducer = (state = initialSettings, action: CategoryActions) => {
  
    switch (action.type) {
      case GET_CATEGORIES:
        const categories: Category[] | undefined = action.payload;
        return {
          ...state,
          categories: categories
        };
      default:
        return state;
    }
  };
  
  export default CategoryReducer;
  